import AppContainer from '../containers/App/AppContainer';
import { AsyncDomain } from '../domains/index';

import RouteBuilder from './RouteBuilder';
import {
  createConditionalComponent,
  errorLoading,
  isCuratorExperienceEnabled,
  isLoggedInUser,
  isResponsiveSubscriptionEnabledWrapper,
  onChangeLanding,
  onChangeUpgradeFlow,
  onEnterBackstage,
  onEnterBrowse,
  onEnterFamilyPlanManagement,
  onEnterLanding,
  onEnterMobileAccountWelcome,
  onEnterMobileMessage,
  onEnterPartnerUpgradeFlow,
  onEnterPaypalCancel,
  onEnterPaypalComplete,
  onEnterPlans,
  onEnterPlaylist,
  onEnterPodcastBSP,
  onEnterSettings,
  onEnterSubscriptionManagement,
  onEnterUpgradeFlow,
  onEnterVerification,
  onLeavePlaylist,
  redirectIfAuthenticated,
  redirectIfAuthenticatedOnChange,
  redirectIfAuthenticatedOrBlocked,
  redirectPlaybackToBackstage,
  redirectToPartnerUpgrade,
} from './Routes';

export default (store, isMobileWeb, isTablet) =>
  RouteBuilder.mobileRouteBuilder({
    isMobileWeb,
    isTablet,
    onEnterBackstage,
    AppContainer,
    onEnterLanding: onEnterLanding(store),
    onChangeLanding: onChangeLanding(store),
    errorLoading,
    AsyncDomain,
    onEnterPodcastBSP: onEnterPodcastBSP(store),
    onEnterPlaylist,
    onLeavePlaylist,
    createConditionalComponent,
    redirectPlaybackToBackstage: redirectPlaybackToBackstage(store),
    redirectIfAuthenticated: redirectIfAuthenticated(store),
    redirectIfAuthenticatedOnChange: redirectIfAuthenticatedOnChange(store),
    redirectIfAuthenticatedOrBlocked: redirectIfAuthenticatedOrBlocked(store),
    isLoggedInUser: isLoggedInUser(store),
    onEnterUpgradeFlow: onEnterUpgradeFlow(store),
    onChangeUpgradeFlow: onChangeUpgradeFlow(store),
    onEnterMobileAccountWelcome: onEnterMobileAccountWelcome(store),
    onEnterFamilyPlanManagement: onEnterFamilyPlanManagement(store),
    redirectToPartnerUpgrade: redirectToPartnerUpgrade(store),
    onEnterPartnerUpgradeFlow: onEnterPartnerUpgradeFlow(store),
    onEnterMobileMessage: onEnterMobileMessage(store),
    onEnterVerification: onEnterVerification(store),
    onEnterPlans: onEnterPlans(store),
    onEnterPaypalCancel: onEnterPaypalCancel(store),
    onEnterPaypalComplete: onEnterPaypalComplete(store),
    onEnterBrowse: onEnterBrowse(store),
    onEnterSettings: onEnterSettings(store),
    onEnterSubscriptionManagement: onEnterSubscriptionManagement(store),
    isResponsiveSubscriptionEnabled: isResponsiveSubscriptionEnabledWrapper(store),
    isCuratorExperienceEnabled: isCuratorExperienceEnabled(store),
  });
